"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./src/IContact"), exports);
__exportStar(require("./src/IAuthenticate"), exports);
__exportStar(require("./src/IBaseModel"), exports);
__exportStar(require("./src/IClient"), exports);
__exportStar(require("./src/IAppointment"), exports);
__exportStar(require("./src/ILoyaltyPoint"), exports);
__exportStar(require("./src/IOrganization"), exports);
__exportStar(require("./src/IOrganizationTask"), exports);
__exportStar(require("./src/IOrganizationUser"), exports);
__exportStar(require("./src/IPayment"), exports);
__exportStar(require("./src/IReport"), exports);
__exportStar(require("./src/IResponses"), exports);
__exportStar(require("./src/IServiceProvider"), exports);
__exportStar(require("./src/IServiceProviderAvailability"), exports);
__exportStar(require("./src/IUser"), exports);
__exportStar(require("./src/IUserFavoriteOrganization"), exports);
__exportStar(require("./src/enum"), exports);
